import React, { useState, useEffect } from 'react'
import {
    getEmailTempaltesforCollection, getSmsTempaltesforCollection, getWhatsappTempaltesforCollection, getCommunicationPreiviwTempalteByTemplateId, sendDirectTemplateUsingTempalteidAndType
    , getRecoveryAllcommentList, getcommunicationListByLoanId, SaveOrUpdatecommentRecoveryByData, getRecoveryCommentsByEmiId
} from '../AdminActionCreator.component'
import Popup from '../../../presentationals/Popup/Popup.component';
import Loader from '../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';

const itemsPerPage = 10;
const generateTimeOptions = () => {
        const times = [];
        const start = new Date();
        start.setHours(8, 0, 0, 0); // 8:00 AM
        const end = new Date();
        end.setHours(18, 0, 0, 0); // 6:00 PM

        while (start <= end) {
            const hours = start.getHours();
            const minutes = start.getMinutes();
            const formattedTime = start.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
            times.push(formattedTime);
            start.setMinutes(minutes + 15); // +15 minutes
        }

        return times;
    };


export default function RecoveryCommunicationNew({ dataForCommunication, admin, collectionType, pagetype }) {
    const [loader, setLoader] = useState(false)
    const [commType, setcommType] = useState("mail")
    const [templateList, setTemplateList] = useState([])
    const [selectedTemplate, setSelectedTemplateId] = useState({})
    const [previewData, setPreviewData] = useState("")
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [AllcommentList, setAllcommentList] = useState([])
    const [commentList, setcommentList] = useState([])
    const [PaginatedData, setPaginatedData] = useState([])
    const [commentPopup, setcommentPopup] = useState(false)
    const [currentPage, setcurrentPage] = useState(1)
    const [commentPayload, setcommentPayload] = useState({
        comment: "",
        date: "",
        remark: "",
    })

    useEffect(() => {
        setcommType(pagetype)
        if (pagetype == "msg") {
            getSmsTempaltesforCollectionFn()
        }
        if (pagetype == "mail") {
            getEmailTempaltesforCollectionFn()
        }
        if (pagetype == "Whatsapp") {
            getWhatsappTempaltesforCollectionFn()
        }
        if (pagetype == "comment") {
            getRecoveryAllcommentListFn()
            getcommunicationListByLoanIdFn()
        }
        setPreviewData("")
        setSelectedTemplateId({})
    }, [pagetype])


    const getRecoveryAllcommentListFn = () => {
        setLoader(true)
        getRecoveryAllcommentList(callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback?.length > 0) {
                setAllcommentList(callback)
            } else {
                setAllcommentList([])
            }
        })
    }
    const getcommunicationListByLoanIdFn = () => {
        setLoader(true)
        // getcommunicationListByLoanId(dataForCommunication?.loanId, callback => {
        //     setLoader(false)
        //     console.log("call", callback)
        //     if (callback?.status == 200 && callback?.data?.length > 0) {
        //         setcommentList(callback?.data)
        //         paginate(callback?.data,1)
        //         setcurrentPage(1)
        //     } else {
        //         setcommentList([])
        //         setPaginatedData([])
        //     }
        // })
        getRecoveryCommentsByEmiId(dataForCommunication?.loanId, dataForCommunication?.emidId, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setcommentList(callback?.data)
                paginate(callback?.data, 1)
                setcurrentPage(1)
            } else {
                setcommentList([])
                setPaginatedData([])
            }
        })
    }
    const getEmailTempaltesforCollectionFn = () => {
        setLoader(true)
        getEmailTempaltesforCollection(callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data)
            } else {
                setTemplateList([])
            }
        })
    }
    const getSmsTempaltesforCollectionFn = () => {
        setLoader(true)
        getSmsTempaltesforCollection(callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data)
            } else {
                setTemplateList([])
            }
        })
    }
    const getWhatsappTempaltesforCollectionFn = () => {
        setLoader(true)
        getWhatsappTempaltesforCollection(callback => {
            setLoader(false)
            console.log("call", callback?.data)
            if (callback?.status == 200 && callback?.data?.length > 0) {
                setTemplateList(callback?.data)
            } else {
                setTemplateList([])
            }
        })
    }


    const msgTempleteClick = (data) => {

        setSelectedTemplateId(data)
        const obj = {
            templateId: pagetype == "msg" ? data?.smsId : pagetype == "mail" ? data?.emailId : pagetype == "Whatsapp" ? data?.whatsappId : "",
            commType: pagetype == "msg" ? 'SMS' : pagetype == "mail" ? 'EMAIL' : pagetype == "Whatsapp" ? 'WHATSAPP' : "",
            userId: dataForCommunication?.userId,
        }
        setLoader(true)
        getCommunicationPreiviwTempalteByTemplateId(obj?.templateId, obj?.commType, obj?.userId, callback => {
            setLoader(false)
            console.log("ca", callback)
            if (callback?.status == 200) {
                setPreviewData(callback?.data)
            } else {
                setPreviewData("")
            }
        })
    }

    const handleSendMsg = () => {
        const obj = {
            templateId: pagetype == "msg" ? selectedTemplate?.smsId : pagetype == "mail" ? selectedTemplate?.emailId : pagetype == "Whatsapp" ? selectedTemplate?.whatsappId : "",
            commType: pagetype == "msg" ? 'SMS' : pagetype == "mail" ? 'EMAIL' : pagetype == "Whatsapp" ? 'WHATSAPP' : "",
            userId: dataForCommunication?.userId,
        }
        setLoader(true)
        sendDirectTemplateUsingTempalteidAndType(obj?.templateId, obj?.commType, obj.userId, callback => {
            setLoader(false)
            if (callback == "success") {
                setpopup({
                    show: true,
                    popupStatus: pagetype == "msg" ? "Message Sent Successfully" : pagetype == "mail" ? "Mail Sent Successfully" : pagetype == "Whatsapp" ? "Message Sent Successfully" : "",
                })
                setPreviewData("")
                setSelectedTemplateId({})
            } else {
                setpopup({
                    show: true,
                    popupStatus: "Please Try Again",
                })
            }
            removePopup()
        })

    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handlecommentPopup = (value) => {
        setcommentPopup(value)
        setcommentPayload({
            comment: "",
            date: "",
            remark: "",
        })
    }

    const handleSavecomment = () => {
        console.log("dataForCommunication", dataForCommunication)
        const data = {
            "loanId": dataForCommunication?.loanId,
            "comment": commentPayload?.comment,
            "remark": commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ? commentPayload?.date + "T" + commentPayload?.remark : commentPayload?.remark,
            "commentBy": admin?.emailId,
            "emiId": dataForCommunication?.emiId || ""
        }

        setLoader(true)
        SaveOrUpdatecommentRecoveryByData(data, callback => {
            setLoader(false)
            if (callback == 'success') {
                setpopup({ show: true, popupStatus: 'Comment Saved Successfully' })
            } else {
                setpopup({ show: true, popupStatus: 'Error Saving Comment' })
            }
            handlecommentPopup(false)
            getcommunicationListByLoanIdFn()
            removePopup()
        })
    }

    const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        paginate(commentList, value)
    };

    const paginate = (data, page) => {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const sliced = data.slice(startIndex, endIndex);
        setPaginatedData(sliced);
    };


    return (
        <>
            <div className="container-fluid">
                {
                    loader ? <Loader /> : ''
                }
                {
                    popup?.show ?
                        <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                        : ''}
                {
                    !(pagetype == "comment") ?

                        <div className="row">
                            <div className="col-sm-5 col-xs-12">
                                <h3 className=" text-center blue-text">Templates</h3>
                                {collectionType == 'recovery' ?
                                    <ol>
                                        {
                                            templateList && templateList?.length > 0 ? templateList?.map((value, id) => {
                                                return (
                                                    <li>
                                                        <input type="radio" name="communicationMsg" checked={pagetype == "msg" ? value?.smsId === selectedTemplate?.smsId ? true : false : pagetype == "mail" ? value?.emailId == selectedTemplate?.emailId ? true : false : pagetype == "Whatsapp" ? value?.whatsappId == selectedTemplate?.whatsappId ? true : false : false} onClick={e => msgTempleteClick(value)} /> &nbsp;&nbsp;
                                                        <span><strong>{pagetype == "msg" ? value?.messageDescription : pagetype == "mail" ? value?.emailSubject : pagetype == "Whatsapp" ? value?.whatsappSubject : ""}</strong></span>
                                                    </li>
                                                )
                                            })
                                                : ''}
                                    </ol>
                                    : ''}
                            </div>

                            {
                                previewData !== "" ?
                                    <div className="col-sm-7 col-xs-12">
                                        <div className="col-xs-12">
                                            {
                                                pagetype == "mail" ?
                                                    <div style={{ height: '300px', overflowY: 'auto', borderRadius: '6px', padding: '10px', boxShadow: '3px 3px 8px 3px #dadada' }}>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: previewData
                                                            }}
                                                        ></div>
                                                    </div>
                                                    : ''}
                                            {
                                                pagetype == "msg" || pagetype == "Whatsapp" ?
                                                    <div style={{ height: '300px', overflowY: 'auto', borderRadius: '6px', padding: '10px', boxShadow: '3px 3px 8px 3px #dadada' }}>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: previewData
                                                            }}
                                                        ></div>
                                                    </div>
                                                    : ''}
                                        </div>

                                        <div className="col-xs-12">
                                            <button className="profile-save-btn center-block" onClick={e => handleSendMsg()}>SEND</button>
                                        </div>
                                    </div>
                                    : ''}
                        </div>

                        :

                        <div className="row">
                            <div className="col-xs-12" style={{ marginTop: '30px' }}>
                                <div>
                                    <button className='btn btn-primary' onClick={() => handlecommentPopup(true)}>Add Comment</button>
                                </div>
                                <div className='phocket-table-new' >
                                    <table className="text-center ">
                                        <thead>
                                            <tr>
                                                <th>Comment By</th>
                                                <th>Comment</th>
                                                <th>Remark</th>
                                                <th>Added On</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PaginatedData?.length > 0 ? PaginatedData?.map((recData, i) => {
                                                return (
                                                    <tr key={i}>

                                                        <td>{recData?.commentBy ?? ""}</td>
                                                        <td>{recData?.comment ?? ""}</td>
                                                        <td>{recData?.remark ?? ""}</td>
                                                        <td>{recData?.addedAt ?? ""}</td>

                                                    </tr>
                                                )
                                            }) : ''}
                                        </tbody>
                                    </table>
                                    <div style={{ display: 'flex', justifyContent: 'end', margin: '20px 0' }}>
                                        <Pagination color="primary"
                                            count={Math.ceil(commentList?.length / itemsPerPage)}
                                            page={currentPage}
                                            onChange={handlePagePagination}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>

            {
                commentPopup ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '20%' }}>
                            <i onClick={() => handlecommentPopup(false)} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div>
                                <h3 className='text-center'>Add Comment</h3>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                <div style={{ textAlign: 'left' }}>
                                    <label htmlFor="">Select Comment</label>
                                    <select className='form-control' value={commentPayload?.comment} onChange={(e) => setcommentPayload({ remark: "", "comment": e.target.value ,date: ""})} style={{
                                        width: commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ? '70%' : "100%"
                                    }}>
                                        <option value="">Select</option>
                                        {
                                            AllcommentList && AllcommentList?.length > 0 ? AllcommentList?.map((v) => {
                                                return (
                                                    <option value={v}>{v}</option>
                                                )
                                            })
                                                : ''}
                                    </select>
                                </div>
                                {/* {
                                    commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                        <div style={{ textAlign: 'left' }}>
                                            <label htmlFor="">{commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" ? "Time" : "Date & Time"}</label>
                                            <input
                                                className='form-control'
                                                type={commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" ? "time" : 'datetime-local'}
                                                value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }} />
                                        </div>
                                        : ''} */}
                                {
                                    commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                        <div style={{ textAlign: 'left' }}>
                                            <label htmlFor="">Date</label>
                                            <input
                                                className='form-control'
                                                type="date"
                                                value={commentPayload?.date} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "date": e.target.value }))} style={{ width: '100%' }} />
                                        </div>
                                        : ''}
                                {
                                    commentPayload?.comment == "Will pay today" || commentPayload?.comment == "Will pay today - Part payment" || commentPayload?.comment == "Will pay tomorrow" || commentPayload?.comment == "Will pay in a few days" || commentPayload?.comment == "Promised to Pay on" || commentPayload?.comment == "Will Inform to pay" ?
                                        <div style={{ textAlign: 'left' }}>
                                            <label htmlFor="">Time</label>
                                            <select className='form-control' value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }} >

                                                <option value="">Select</option>
                                                {
                                                    generateTimeOptions()?.map((time, index) => (
                                                        <option key={index} value={time}>
                                                            {time}
                                                        </option>
                                                    ))
                                                }


                                            </select>

                                        </div>
                                        : ''}
                                {
                                    commentPayload?.comment == "Language Barrier" ?
                                        <div style={{ textAlign: 'left' }}>
                                            <label>Language</label>
                                            <select className='form-control' value={commentPayload?.remark} onChange={(e) => setcommentPayload((prev) => ({ ...prev, "remark": e.target.value }))} style={{ width: '100%' }}>
                                                <option value={""}>Select</option>
                                                <option value={"Hindi"}>Hindi</option>
                                                <option value={"English"}>English</option>
                                                <option value={"Bengali"}>Bengali</option>
                                                <option value={"Odia"}>Odia</option>
                                                <option value={"Tamil"}>Tamil</option>
                                                <option value={"Telugu"}>Telugu</option>
                                                <option value={"Kannada"}>Kannada</option>
                                            </select>
                                        </div>
                                        : ""}
                            </div>
                            <div className='text-center' style={{ marginTop: '15px' }}>
                                <button className='btn btn-primary' disabled={commentPayload?.comment == "" || commentPayload?.comment == null || commentPayload?.comment == undefined ? true : false} onClick={() => handleSavecomment()}>Save</button>
                            </div>
                        </div>
                    </div>
                    : ''}
        </>
    )
}
